import React from "react";
import { object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import ContributorImage from "../../atoms/ContributorImage";
import ProfileHeadline from "../../atoms/ProfileHeadline";

import { getBirthDate, getMember } from "../../utils/utils";

import "./my-profile.m.css";

const MyProfile = ({ member, publisherAttributes }) => {
  const address = get(member, ["metadata", "address"], "-");
  const dob = get(member, ["metadata", "dob"], "-");
  const contactNumber = get(member, ["metadata", "contact-number"], "-");
  const Birthday = getBirthDate(dob);
  const memberObj = getMember(member);

  return (
    <div styleName={`container ${publisherAttributes.lang}-container`}>
      <ProfileHeadline title="My Profile" lang={publisherAttributes.lang} />

      <div styleName="wrapper">
        <ContributorImage authorObj={memberObj} widths={[250]} memberProfilePic={true} />
        <div styleName="profile-details">
          <span styleName="profile-name">{member.name}</span>

          <div styleName="profile-columns">
            <div styleName="label-value">
              <span styleName="label">Email : </span>
              <span styleName="value">{member.email}</span>
            </div>
            <div styleName="label-value">
              <span styleName="label">Country : </span>
              <span styleName="value">{address}</span>
            </div>
          </div>

          <div styleName="profile-columns">
            <div styleName="label-value">
              <span styleName="label">Birthday : </span>
              <span styleName="value">{Birthday}</span>
            </div>
            <div styleName="label-value">
              <span styleName="label">Phone Contact : </span>
              <span styleName="value">{contactNumber}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

MyProfile.propTypes = {
  member: object.isRequired,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps)(MyProfile);
